module.exports = __webpack_public_path__ + "img/shipping.0499316d.png";